import { useEffect, useState } from 'react';
import { useCheckExpiredLinkPasswordMutationApi } from '../api/use-check-expired-link-password-mutation-api';

const getErrorStatusAndMessage = (error: any) => {
  return {
    status:
      error?.response?.status || error?.status || error?.response?.data?.status,
    message: error?.message || error?.response?.data?.error,
  };
};

export function useValidateTransferLink({
  id,
  username,
  firstname,
  lastname,
}: {
  id?: string;
  username?: string;
  firstname?: string;
  lastname?: string;
}) {
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const checkApi = useCheckExpiredLinkPasswordMutationApi(id as string);

  useEffect(() => {
    if (!id || !username || !firstname || !lastname) return;

    checkApi
      .mutateAsync({
        captcha: '123456',
        user: {
          username,
          firstName: firstname,
          lastName: lastname,
        },
      })
      .then(() => setIsValid(true))
      .catch((error) => {
        const { status, message } = getErrorStatusAndMessage(error);
        if (status === 404 || message === 'invitation is invalid or expired') {
          setIsValid(false);
        } else {
          console.error('Unexpected error during invite check:', error);
        }
      });
  }, [id, username, firstname, lastname]);

  return isValid;
}
